import { permissionsRol as settingsRol } from 'app/policies/roles/settingsRol.access';
import {
  PATH_SETTINGS,
  PATH_SETTINGS_COUNTRIES,
  PATH_SETTINGS_COUNTRY,
  PATH_SETTINGS_DISCIPLINES,
  PATH_SETTINGS_LEARNING_OBJECTIVES,
  PATH_SETTINGS_TENANT_PARAMS,
} from 'app/router/routesConfigSetting';

export function settingsApp(path, user, settings) {
  const { is_multicountry } = settings;

  if (PATH_SETTINGS === path) {
    return settingsRol(user).sectionSettings;
  }

  if (PATH_SETTINGS_COUNTRIES === path) {
    return settingsRol(user).sectionSettings && is_multicountry;
  }

  if (PATH_SETTINGS_COUNTRY === path) {
    return settingsRol(user).sectionSettings && is_multicountry;
  }

  if (PATH_SETTINGS_DISCIPLINES === path) {
    return settingsRol(user).disciplinesSettings && !is_multicountry;
  }

  if (PATH_SETTINGS_LEARNING_OBJECTIVES === path) {
    return settingsRol(user).sectionSettings;
  }

  if (PATH_SETTINGS_TENANT_PARAMS === path) {
    return settingsRol(user).tenantParamsSettings;
  }

  return true;
}
